import React from 'react';
import { GenericFunction, MouseHandler } from './utilityTypes';

export const preventAndCall =
    <T extends React.SyntheticEvent>(fn: (event: T) => void) =>
    (event: T): void => {
        stopAndPrevent(event);
        return fn(event);
    };

// To be defined when we integrate with trackers
export type Tracker = GenericFunction;

export function stopAndPrevent<T extends React.SyntheticEvent>(event: T): void {
    event.stopPropagation();
    event.preventDefault();
}

export function stopPropagation<T extends React.SyntheticEvent>(
    event: T
): void {
    event.stopPropagation();
}

export function preventDefaultKeys(
    keys: string[]
): (event: React.KeyboardEvent) => void {
    return function preventKey(event: React.KeyboardEvent): void {
        if (keys.includes(event.key)) event.preventDefault();
    };
}

export function openInNewTab(link: string): void {
    window.open(link, '_blank');
}

function createHandler(
    link: string,
    tracker: Tracker = () => {
        return;
    }
): MouseHandler {
    return event => {
        stopAndPrevent(event);
        openInNewTab(link);
        tracker();
    };
}

export function createWhatsappHandler(
    whatsappLink: string,
    tracker?: Tracker
): MouseHandler {
    return createHandler(whatsappLink, tracker);
}

export function createPhoneHandler(
    phone: string,
    tracker?: Tracker
): MouseHandler {
    return createHandler(`tel:${phone}`, tracker);
}

export function createEmailHandler(
    email: string,
    tracker?: Tracker
): MouseHandler {
    return createHandler(`mailto:${email}`, tracker);
}
